import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import AssetsPage from '../components/AssetsPage'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetsPage)
